import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";

export interface SourceFilesListContextMenuProps {
    show: boolean;
    coords: { x: number; y: number };
    removeSelectedFiles: () => void;
}

function SourceFilesListContextMenu(props: SourceFilesListContextMenuProps) {
    if (!props.show) {
        return null;
    }

    return (
        <ul
            className="p-0 rounded source-files-list-item-context-menu d-flex align-items-start justify-content-center flex-column"
            style={{ left: props.coords.x, top: props.coords.y }}
            onPointerDown={(e) => {
                e.stopPropagation();
            }}
        >
            <li className="rounded">
                <button
                    className="btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        props.removeSelectedFiles();
                    }}
                >
                    <span className="gap-2 d-flex align-items-center">
                        <FontAwesomeIcon icon={faTrash} />
                        Remove selected item(s)
                    </span>
                </button>
            </li>
        </ul>
    );
}

export default SourceFilesListContextMenu;
